import { render } from "./AlternativeLabelsEditorPage.vue?vue&type=template&id=603a0e31&ts=true"
import script from "./AlternativeLabelsEditorPage.vue?vue&type=script&lang=ts"
export * from "./AlternativeLabelsEditorPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__